import type { RenderPlaceholderProps } from 'slate-react';

import { cn } from '@mint-lib/tw-utils';

import { typographyVariants } from '../../lib/typography.jsx';

export function renderEditorPlaceholder({
  children,
  attributes,
}: RenderPlaceholderProps) {
  return (
    <span
      className={cn(
        typographyVariants({ variant: 'bodyShort01', color: 'placeholder' }),
        'flex! items-start! pt-1 opacity-100!',
      )}
      {...attributes}
    >
      {children}
    </span>
  );
}
